import * as React from 'react';
const SvgStarFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 8 8" fill="none" {...props}>
        <path
            d="M4 6.424L1.902 7.701a.325.325 0 01-.485-.353l.565-2.39L.12 3.356a.325.325 0 01.185-.57l2.448-.201L3.7.319a.325.325 0 01.6 0l.948 2.266 2.448.201a.325.325 0 01.185.57L6.019 4.958l.565 2.39a.325.325 0 01-.485.353L4 6.424z"
            fill="currentColor"
        />
    </svg>
);
export default SvgStarFilled;
